export default __webpack_public_path__ + "static/media/Interior (9).eea09125.jpg";